import { mapMutations } from "vuex"

import cookies from '@/utils/cookie'

export default {
  methods: {
    ...mapMutations(['setBindDialog', 'setUser', 'setSelectedRole']),
    login() {
      this.$emit('login')
    },
    logout() {
      this.setUser({})
      this.setSelectedRole({})
      cookies.remove('cqytj', 'userInfo')
      
      this.$router.go(0)
    },
    bindRole() {
      this.setBindDialog({ visible: true })
    },
  }
}